import { combineDucks } from "lib/utils/duck";

import AddOrderTransferModal from "./AddOrderTransferModal";
import ChangeOrderScheduleSlotModal from "./ChangeOrderScheduleSlotModal";
import EditOrderCustomerDetailsModal from "./EditOrderCustomerDetailsModal";
import EditOrderInstallmentsModal from "./EditOrderInstallmentsModal";
import EditOrderItemsModal from "./EditOrderItemsModal";
import EditOrderNotesModal from "./EditOrderNotesModal";
import FinishOrderModal from "./FinishOrderModal";
import NewOrderModal from "./NewOrderModal";
import OrdersListView from "./OrdersListView";
import ShowOrderView from "./ShowOrderView";
import utils from "./utils";

export default combineDucks({
  AddOrderTransferModal,
  ChangeOrderScheduleSlotModal,
  EditOrderCustomerDetailsModal,
  EditOrderInstallmentsModal,
  EditOrderItemsModal,
  EditOrderNotesModal,
  FinishOrderModal,
  NewOrderModal,
  OrdersListView,
  ShowOrderView,
  utils,
});



// WEBPACK FOOTER //
// ./src/modules/orders/index.js